import React, { useEffect } from "react";
import { Center } from "../../../styles/component/style";
import { AccountVerification } from "../../internal/AccountVerification/AccountVerification";
import { Header } from "../../internal/Header/Header";
import AuthService from "../../../services/AuthService";
import { useSnackbar } from "notistack";
import useLoader from "../../../hooks/useLoader";
import { navigate } from "@reach/router";
import { getErrorMessage } from "../../../helpers/functions";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";

const Index = ({ location }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const { state } = location;
  async function resendEmail() {
    try {
      setLoader({ state: true, message: "Sending verfication email..." });
      const payload = { email: state.email, role: state.role };
      const response = await AuthService.forgotPassword(payload);
      if (response) {
        enqueueSnackbar(
          `Please check your email inbox ${state.email} to reset your password`,
          {
            variant: "success",
          },
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
      navigate("/");
    } finally {
      setLoader({ state: false });
    }
  }
  useEffect(() => {
    if (state?.email) {
      resendEmail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.email]);
  if (!state?.email) navigate("/dashboard/login");
  return (
    <Header>
      <Center>
        <AccVerifyContainer>
          <AccountVerification
            heading="FORGOT PASSWORD"
            timer={60}
            isTimmerEnabel={true}
            message={`We’ve sent a reset password link to your registered email. Please check your inbox and update your password to access your account`}
            triggerResent={resendEmail}
            location={location}
          />
        </AccVerifyContainer>
      </Center>
    </Header>
  );
};

export default Index;

export const AccVerifyContainer = styled.div`
  background: ${COLORS.PRIMARY_WHITE};
  border-radius: 11px;
  width: 700px;
  margin: 20px 0px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    width: 90vw;
    padding: 30px 30px;
  }
`;
